import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
	selector: 'app-search-bar',
	templateUrl: './search-bar.component.html',
	styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent {
	filterString: string;

	/**
	 * Input to specify the placeholder text of the search box. If no value is provided the
	 * default value of "search" will be used.
	 */
	@Input()
	placeholderText = 'search';

	/**
	 * Input to specify the start search value of the search box. If no value is provided the
	 * default value of "" will be used.
	 */
	@Input()
	startingSearchValue = '';

	/**
	 * Input to specify the search input field will allow for autocomplete as implemented by the broswer.
	 * If no value is provided the default value of "off" will be used. The alternative is to provide the
	 * value of "on".
	 */
	@Input()
	fieldAutocomplete = 'off';

	/**
	 * Input to enable or disable instaSearch using a boolean. If no value is provided, instaSearch will the
	 * be enabled with the default value of true.
	 */
	@Input()
	instaSearchEnabled = true;

	/**
	 * Input to specify the id of the search box. If no value is provided the default value
	 * of "search" will be used.
	 */
	@Input()
	searchFieldId = 'search';

	/**
	 * Input to specify the name of the search box. If no value is provided the default value
	 * of "search" will be used.
	 */
	@Input()
	searchFieldName = 'search';

	/**
	 * Output which emits a string to the parent component
	 */
	@Output()
	searchClicked = new EventEmitter<string>();

	constructor() {}

	/**
	 * Triggered when the value in the text box changes. If instaSearch is enable this will
	 * call the search function.
	 * @param searchString
	 */
	keyUp(searchString: string) {
		if (this.instaSearchEnabled) {
			this.search(searchString);
		}
	}

	/**
	 * Triggered when the search button is clicked or by the keyUp function. This function
	 * emits the search value up to the parent component.
	 * @param searchString
	 */
	search(searchString: string) {
		this.searchClicked.emit(searchString);
	}
}
